import { useState } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhyUs from './components/WhyUs';
import Flow from './components/Flow';

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');

  const scrollToSection = (sectionId: string) => {
    setActiveSection(sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <i className="ri-windy-line text-2xl text-cyan-600"></i>
              <span className="text-xl font-bold text-slate-800">合同会社ｌｕｃｅ</span>
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-slate-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                ホーム
              </button>
              <button 
                onClick={() => scrollToSection('why-us')}
                className="text-slate-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                選ばれる理由
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-slate-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                サービス
              </button>
              <button 
                onClick={() => scrollToSection('flow')}
                className="text-slate-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                ご利用の流れ
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-slate-700 hover:text-cyan-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                会社概要
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-cyan-600 text-white px-6 py-2 rounded-md hover:bg-cyan-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                お問い合わせ
              </button>
            </div>
            <button className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer">
              <i className="ri-menu-line text-2xl text-slate-700"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        <div id="home">
          <Hero scrollToContact={() => scrollToSection('contact')} />
        </div>
        <div id="why-us">
          <WhyUs />
        </div>
        <div id="services">
          <Services />
        </div>
        <div id="flow">
          <Flow />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </main>

      <Footer />
    </div>
  );
}
